/* Mobile default: vertical list, date badge on the left (MobileVenue.dc.html's schedule). */
.days {
  background: var(--bg-panel);
  border-radius: var(--r-12);
  display: flex;
  flex-direction: column;
}

.dayCard {
  display: flex;
  gap: 14px;
  padding: 12px 14px;
  border-bottom: 1px solid var(--border-2);
}
.dayCard:last-child {
  border-bottom: none;
}

.dateBadge {
  width: 44px;
  flex-shrink: 0;
  text-align: center;
  padding-top: 2px;
}

.dow {
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  color: var(--accent-text);
}

.dayNum {
  display: block;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 26px;
  line-height: 1;
}

.items {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.item {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: baseline;
}

.itemLabel {
  font-size: 15px;
}

.itemTime {
  font-size: 14px;
  color: var(--text-secondary);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.prose {
  background: var(--bg-panel);
  border-radius: var(--r-12);
  padding: 16px;
  font-size: 15px;
  line-height: 1.6;
  color: var(--text-secondary);
}
.prose p {
  margin: 0 0 10px;
}
.prose p:last-child {
  margin-bottom: 0;
}

/* Desktop: horizontal row of day cards (Desktop.dc.html's "Race week" section). */
@media (min-width: 1200px) {
  .days {
    background: transparent;
    border-radius: 0;
    flex-direction: row;
    gap: 10px;
  }

  .dayCard {
    flex: 1;
    min-width: 0;
    flex-direction: column;
    gap: 10px;
    background: var(--bg-panel);
    border-radius: var(--r-12);
    padding: 14px;
    border-bottom: none;
    border-top: 4px solid var(--accent);
  }

  .dateBadge {
    width: auto;
    text-align: left;
    padding-top: 0;
  }

  .items {
    gap: 8px;
  }

  .item {
    flex-direction: column;
    gap: 0;
    align-items: flex-start;
  }

  .itemTime {
    order: -1;
  }
}
